import React, { useState } from "react";
import { Card, Modal } from "antd";
import axios from "axios";
import api from "../../api";
import ExcelIcon from "../../images/excel-file-type-svgrepo-com.svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useTheme } from '../../contexts/ThemeContext';


const excelItems = [
  { key: "allUser", label: "خروجی همه کاربران" },
  { key: "seller", label: "خروجی همه سفارش‌ها" },
  { key: "allPay", label: "خروجی همه پرداخت‌ها" },
  { key: "allProduct", label: "خروجی همه محصولات" },
  { key: "allPayMeta", label: "خروجی محصولات خریداری شده" },
  { key: "allComment", label: "خروجی همه دیدگاه‌ها" },
  // { key: "allTicket", label: "خروجی همه درخواست‌ها" },
  // { key: "allNews", label: "خروجی همه خبرها" },
  // { key: "allEvent", label: "خروجی همه رویدادها" },
];

const ExcelExportPage = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDataKey, setSelectedDataKey] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleCardClick = (dataKey) => {
    setSelectedDataKey(dataKey);
    setIsModalVisible(true);
  };

  const handleModalOk = async () => {
    if (!fromDate || !toDate) {
      alert("لطفاً هر دو تاریخ را انتخاب کنید.");
      return;
    }
  
    // تبدیل تاریخ شمسی به رشته و جایگزینی اعداد فارسی با انگلیسی
    const convertToEnglishNumbers = (str) => str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  
    const formattedFromDate = convertToEnglishNumbers(fromDate.format("YYYY-MM-DD"));
    const formattedToDate = convertToEnglishNumbers(toDate.format("YYYY-MM-DD"));
  
    const url = `/panel/excel/export/${selectedDataKey}`;
    try {
      const response = await api.post(
        url,
        {
          from: formattedFromDate,
          to: formattedToDate,
        },
        {
          responseType: "blob",
        }
      );
  
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${selectedDataKey}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting Excel:", error);
    }
  
    setIsModalVisible(false);
    setFromDate(null);
    setToDate(null);
  };
  

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setFromDate(null);
    setToDate(null);
  };

  return (
    <Card>
      <h1 className="text-2xl font-bold">اکسل‌ها </h1>

      <div className="grid grid-cols-3 gap-4 p-6 bg-gray-100">
        {excelItems.map((item) => (
          <Card
            key={item.key}
            className="flex items-center justify-center p-4 shadow-md rounded-2xl cursor-pointer hover:shadow-lg transition-all"
            onClick={() => handleCardClick(item.key)}
          >
            <div className="flex flex-col items-center justify-center w-full h-full">
              <img src={ExcelIcon} alt="Excel Icon" className="w-12 h-12 mb-2" />
              <span className="text-gray-700 text-sm text-center">{item.label}</span>
            </div>
          </Card>
        ))}
      </div>

      <Modal
        title="انتخاب بازه تاریخ"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="تأیید"
        cancelText="لغو"
      >
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col space-y-2">
            <label className="text-sm font-medium text-gray-700">از تاریخ:</label>
            <DatePicker
              value={fromDate}
              onChange={(date) => setFromDate(date)}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex flex-col space-y-2">
            <label className="text-sm font-medium text-gray-700">تا تاریخ:</label>
            <DatePicker
              value={toDate}
              onChange={(date) => setToDate(date)}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </Modal>
    </Card>
  );
};

export default ExcelExportPage;